import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

function Returns() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main id="page-content-layer">
        <div className="policy-page">
          <div className="policy-container">
            <h1>Returns & Exchanges</h1>
            <p className="policy-intro">
              We want you to love every purchase. If you need to return or
              exchange an item, please review the guidelines below. In case of
              any discrepancy, the official Mangoes policy will prevail.
            </p>

            <section className="policy-section">
              <h2>Return Window</h2>
              <p>
                You may request a return or exchange within 30 days from the
                delivery date. Processing times may be longer during sales or
                holidays.
              </p>
            </section>

            <section className="policy-section">
              <h2>Return Conditions</h2>
              <ul>
                <li>
                  Items must be new, unused, undamaged, and returned with tags,
                  accessories, and original packaging.
                </li>
                <li>
                  For hygiene and safety, underwear, briefs, swimwear bottoms,
                  and earrings cannot be returned or exchanged.
                </li>
                <li>Personalized or altered items are non-returnable.</li>
                <li>
                  Perfumes and select beauty items must be unopened and sealed
                  to be eligible.
                </li>
                <li>Gift cards and e-gift cards are non-refundable.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>How to Return</h2>
              <div className="policy-block">
                <h3>In-Store Return</h3>
                <p>
                  Bring the item and your order proof (digital or paper) to a
                  participating Mangoes store. Refunds will be issued to the
                  original payment method after verification.
                </p>
              </div>
              <div className="policy-block">
                <h3>Courier/Postal Return</h3>
                <p>
                  Pack items securely and ship to the designated address using a
                  trackable service. Unless due to a defect or wrong item sent,
                  return shipping is at the customer’s expense.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Refunds</h2>
              <ul>
                <li>
                  Once your return passes inspection, refunds are processed
                  within 3–15 business days to the original payment method.
                </li>
                <li>
                  Orders with multiple items may be refunded in separate
                  transactions.
                </li>
                <li>
                  For orders using discounts or promotions, the refund amount
                  will reflect applicable rules and prorations.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>FAQs</h2>
              <ul>
                <li>
                  Gift order returns: refunds go back to the original payment
                  method.
                </li>
                <li>
                  Wrong or defective item received: contact customer service
                  immediately for priority assistance.
                </li>
              </ul>
            </section>

            <div className="policy-actions">
              <button className="btn-primary" onClick={toTop}>
                Back to Top
              </button>
              <Link className="link-underline" to="/shop" onClick={toTop}>
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default Returns;
